module.exports = __webpack_public_path__ + "img/amex.0db300e1.png";